import styled from "styled-components";




export const Section = styled.section`
  padding-top: 150px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 100px;
 
/* background-color: aqua; */
 h2 {
  margin-bottom: 80px;

}

h3 {
  margin-bottom: 10px;
}

h4 {
  color: ${props => props.theme.siteColor};
  padding: 5px 0px;
}

p {
  margin-top: 5px;
}

button {
  margin-top: 30px;
  width: 150px;
  padding: 5px;
  background-color: black;
  border: 1px solid ${props => props.theme.siteColor};
  color: ${props => props.theme.siteColor};
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.4s;
}

 button:hover {
  transform: scale(1.1);
  background-color: ${props => props.theme.siteColor};
  color: black;
}


`




export const Container = styled.div`
width: 100%;
display: flex;
justify-content: space-around;
flex-wrap: wrap;

`





export const Course = styled.div`
padding: 20px;
max-width: 380px;
min-width: 300px;
     width: 80%;


display: flex;
flex-direction: column;
align-items: center;

margin-bottom: 50px;



a{

  width: 100%;
  text-align: center;
}

h3{
  text-align: left;
}
  h3::before {
    content: "";  
  display: inline-block;
  margin-right: 20px;
   width: ${props => props.width}px;
   height: ${props => props.height}px;
  background: url(${props => props.url}) center;
  background-size: cover;

}



span{
  margin-top: 30px;
}

`




export const Subscribe = styled.p`
 padding: 10px 0px;
  font-size: 14px !important;
  color: ${props => props.theme.subscribeCoursesColor};
  width: 100%;
`


